import Spinner from 'src/javascripts/components/utilities/Spinner';
import ToggleNewData from './ToggleNewData';
import ToastCustom from '../../alerts/ToastCustom';

export default function(parentContainer) {
  let accountUrl = $('body').attr('data-account-url');
  let surveySlug = $('.polling-indicator').attr('data-slug');

  parentContainer.find('input.supporting-links').on('blur paste', function() {
    let el = $(this);
    setTimeout(function() {
      let link = (el.val() || '').trim();
      if (link.length > 3) {
        let existingLink = el
          .closest('.question-row')
          .find('.current-links .document-row .document-name')
          .filter(function() { return $(this).text().trim() === link; });

        if (existingLink.length !== 0) {
          ToastCustom({
            title: 'Already attached',
            message: 'You have already attached that link to this response.',
            type: 'information'
          });
          el.val('').blur();
          return;
        }

        let accountUrl = $('body').attr("data-account-url");
        let answerId = el.attr('data-answer-id');

        // Set card body to indicate value changed for reloading page
        let cardBody = el.closest('.card-body.survey-card-body');
        let card = el.closest('.card');
        cardBody.attr('data-val-changed', 'true');

        // Set spinner so user knows in progress
        cardBody.addClass('opaque');
        Spinner(card);

        // Blur
        el.val('').blur();

        // Upload file
        let url = "/" + accountUrl + '/surveys/' + surveySlug + '/documents';
        let formData = {}
        formData['file'] = {}
        formData['file_type'] = "link";
        formData['file']['key'] = link;
        formData['answer_id'] = answerId;

        // Toggle new data so link/doc gets sent with save
        ToggleNewData(el);

        // Update links count indicator
        let linksCountSpan = el.closest('.question-row').find('.uploaded-links-count');
        let currentCount = parseInt(linksCountSpan.text().replace('(', '').replace(')', '')) || 0;
        let incrementedCount = false;
        if (linksCountSpan.length !== 0) {
          linksCountSpan.text('(' + (currentCount + 1) + ')');
          linksCountSpan.removeClass('d-none');
          incrementedCount = true;
        }

        // Update local attribute
        $.ajax({
          type: 'POST',
          url: url,
          dataType: "script",
          data: formData
        }).fail(function() {
          if (incrementedCount) {
            let updatedCount = Math.max(currentCount, 0);
            linksCountSpan.text('(' + updatedCount + ')');
            if (updatedCount === 0) linksCountSpan.addClass('d-none');
          }

          ToastCustom({
            title: 'Unable to add link',
            message: 'Could not add this link. Please check the URL and try again.',
            type: 'warning'
          });
        }).always(function() {
          cardBody.removeClass('opaque');
          card.find('.spinner-container').remove();
        });
      }
    }, 0);
  });

}
